import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const HearingApprovedAgreement = () => {
  const fileStatus = 20;
  const applicationPath = {
    copyright: "/admin/hearing-approved-copyright",
    agreement: "/admin/hearing-approved-agreement",
  };
  
  // Add route to details page
  const detailsRoute = "/admin/hearing-agreement-details";
  const pageTitle = "শুনানীর চিঠি (অনুমোদিত)";

  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default HearingApprovedAgreement;
